import script from "./LongyingView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LongyingView.vue?vue&type=script&lang=ts&setup=true"

import "./LongyingView.vue?vue&type=style&index=0&id=0c5bb2e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c5bb2e1"]])

export default __exports__